import { TableBody as HeroUiTableBody } from '@heroui/table';

export const TableBody = HeroUiTableBody;
